<template>
  <div class="animated fadeIn pointer wc_crs_icon"
    v-b-tooltip.hover
    :title="base_crs.i18n && base_crs.i18n['EN'] ? base_crs.i18n['EN'].detail : '-'"
    @click="policy_modal = !policy_modal"
    :class="{ 'op-25' : !is_helight() }"
    v-if="total > 0"
  >
  <b-form-checkbox v-if="crs_body.is_toggle" :checked="crs_body.is_toggle_status" style="position: absolute; cursor:pointer;" :disabled="true" ></b-form-checkbox>
  <img v-if="_get_keyword(base_crs)" :src="_get_keyword(base_crs)" width="80" alt="">
  <div style="width: 95%; margin:16px auto 10px; height:1.8px; background-color:rgb(195, 195, 195);"></div>
  <span class="d-block" v-if="base_crs.i18n">
    {{base_crs.i18n['EN'].desc}}
    <div v-if="crs_count_preview && !crs_body.is_toggle">
      <b-badge class="" variant="light">{{preview.disable}}</b-badge>
      <b-badge class="" variant="warning">{{preview.detect}}</b-badge>
      <b-badge class="" variant="danger">{{preview.block}}</b-badge>
    </div>
  </span>

    <!-- <span v-if="_get_keyword(crs)">
      {{_get_keyword(crs)}}
    </span> -->

    <!-- {{crs}} -->
    <!-- 설명 모달 영역 -->
    <b-modal title="Policy Detail"  class="modal-info" v-model="policy_modal" ok-variant="success" header-bg-variant="success" size="xl" no-close-on-backdrop no-close-on-esc>
      <!-- {{crs_body.policy_list}} -->
      <div class="w-100 m-4 float-left">
        <img v-if="_get_keyword(base_crs)" :src="_get_keyword(base_crs)" width="100" alt="" style="vertical-align: top;">
        <div class="d-inline-block ml-5" style="width: 80%;">
          <span class="h4 font-weight-bold">{{base_crs.i18n['EN'].desc}}</span>
          <p class="m-2">{{base_crs.i18n['EN'].detail}}</p>
        </div>
      </div>
      <table class="table text-center">
        <thead class="thead-light">
          <tr>
            <th style="width:100px;">Policy ID</th>
            <th>Policy Name</th>
            <th style="min-width: 120px;" v-if="!base_crs.is_toggle">
              Mode
              <span class="text-info" v-b-tooltip.hover :title="`Available as the default recommended setting, but can be set directly to Disabled, Detected, and Blocked`">
                <i class="fas fa-question-circle"></i>
              </span>
            </th>
            <!-- <th style="min-width: 60px;">Level</th> -->
            <th v-if="!base_crs.is_toggle">Risk</th>
            <!-- TODO : 정보성 추가 -->
            <th v-if="!base_crs.is_toggle">Last 25 Hour (Total)</th>
          </tr>
        </thead>
        <tbody v-for="(r, rindex) in crs_body.policy_list" v-bind:key="r.id">
          <tr v-if="base_crs.policy_list[rindex] && base_crs.policy_list[rindex].i18n && base_crs.policy_list[rindex].is_available && r.level < 2" :style="is_helight(rindex) ? 'opacity : 1; font-weight:bold;' : 'opacity : 0.3; font-weight:normal;' ">
            <td class="text-center">
              {{r.key}}
            </td>
            <td class="text-left">
              <!-- <span v-if="r.level > 1">
                Additional policy to improve accuracy and does not affect blocking
              </span> -->
              <span>
                {{base_crs.policy_list[rindex].i18n['EN'].desc}}
              </span>
              <span class="text-info" v-b-tooltip.hover :title="base_crs.policy_list[rindex].i18n['EN'] ? base_crs.policy_list[rindex].i18n['EN'].detail : '-'">
                <i class="fas fa-question-circle"></i>
              </span>
              <b-badge v-if="r.is_change" class="float-right" variant="dark">Change</b-badge>
            </td>
            <td style="width: 150px" v-if="!base_crs.is_toggle">
              <!-- {{r.mode_origin}} / {{r.mode}} -->
              <!-- {{codes.WAF_MODE_INTERFACE(r.mode)}} -->
              <b-dropdown :text="codes.WAF_MODE_I18N(r.mode, 'EN')" size="sm" :variant="codes.WAF_MODE_TO_COLOR(r.mode, 'variant')">
                <!-- 영문 기준으로 모드 설정 필요 -->
                <b-dropdown-item
                  size="sm"
                  @click="() => { r.is_change = r.mode_origin != codes.WAF_MODE_INTERFACE(x); r.mode = x; }"
                  v-for="(x, index) in codes.WAF_MODE"
                  :key="'_mode'+index"
                >{{codes.WAF_MODE_I18N(x, 'EN')}}</b-dropdown-item>
              </b-dropdown>
            </td>
            <!-- TODO : 향후 레벨 사용시 활용될 수 있음 -->
            <!-- <td style="width: 150px;" v-b-tooltip.hover :title="`해당 정책의 권장 레벨은 ${crs.policy_list[rindex].level}입니다`">
              <b-dropdown :text="r.level" size="sm" :variant="codes.WAF_LEVEL_TO_COLOR(r.level, 'variant')">
                <b-dropdown-item size="sm" @click="r.level = x" v-for="x, index in codes.WAF_LEVEL" :key="'_level'+index" >{{x}}</b-dropdown-item>
              </b-dropdown>
            </td> -->
            <td style="width: 200px;" v-if="!base_crs.is_toggle">
              <!-- {{r.severity_origin}} / {{r.severity}} -->
              <b-dropdown :text="codes.WAF_SEVERITY_TO_DESC_EASY(r.severity, 'EN')" size="sm" :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(r.severity, 'variant')">
                <b-dropdown-item
                @click="() => { r.is_change = r.severity_origin != codes.WAF_SEVERITYS_EASY_TO_DESC(x); r.severity = x; }"
                  size="sm"
                  v-for="(x, index) in codes.WAF_SEVERITYS_EASY"
                  :key="'_severity'+index"
                >
                  {{codes.WAF_SEVERITYS_EASY_TO_DESC(x, 'EN')}}
                </b-dropdown-item>
              </b-dropdown>
              <span class="text-info" v-b-tooltip.hover :title="`The recommended risk for this policy is '${codes.WAF_SEVERITY_TO_DESC_EASY(base_crs.policy_list[rindex].severity, 'EN') }'`">
                <i class="fas fa-question-circle"></i>
              </span>
            </td>
            <td v-if="!base_crs.is_toggle">
              <span v-if="summary && summary[r.key]">
              {{ summary[r.key] | number }}
              </span>
              <span v-else>
                0
              </span>
              <div :style="get_css(summary[r.key])"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 버튼 구역 -->
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left h5 mt-2 text-left ml-4">
            Total : {{ total }}
          </p>
          <!-- base_crs.is_toggle = false -->
          <b-badge class="mt-2 ml-2" v-if="crs_body.is_toggle && crs_body.is_toggle_status_origin != crs_body.is_toggle_status" variant="dark">changed</b-badge>
          <div class="custom-control custom-switch custom-switch-xl ml-4 float-left" v-if="base_crs.is_toggle">
            <input
              @change="x => is_change = true"
              v-model="crs_body.is_toggle_status"
              type="checkbox"
              class="custom-control-input"
              id="switch_toggle_status">
            <label class="custom-control-label" for="switch_toggle_status"></label>
            <p class="mt-2 font-weight-bold" for="switch_toggle_status" style="font-size: 10pt; display:inline-block;">
              {{base_crs.i18n['EN'].desc}} policy {{ crs_body.is_toggle_status ? 'Under Exclusion' : 'Under inspection' }}
            </p>
            <label class="text-info d-inline-block" v-b-tooltip.hover title="Select Enable to exclude" style="cursor: pointer;" >
              <i class="fa fa-question-circle"></i>
            </label>
          </div>
          <!-- base_crs.is_toggle = true -->
          <b-button
            variant="success"
            class="float-right mr-2 ml-2"
            @click="confirm_modal = true"
          >
            Save
          </b-button>
          <b-button
            variant="light"
            class="float-right mr-2 ml-2"
            @click="cancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="danger"
            class="float-right mr-2 ml-2"
            @click="toggle_all_block()"
            v-if="!base_crs.is_toggle"
            >
            All Block
          </b-button>
          <b-button
            variant="warning"
            class="float-right mr-2 ml-2"
            @click="toggle_all_detect()"
            v-if="!base_crs.is_toggle"
            >
            All Detect
          </b-button>
          <b-button
            variant="dark"
            class="float-right mr-2 ml-2"
            @click="toggle_all_off()"
            v-if="!base_crs.is_toggle"
          >
            All Disable
          </b-button>
          <!-- <b-button
            variant="outline-warning"
            class="float-left mr-2 ml-2"
            @click="toggle_default_detect()"
            v-if="!base_crs.is_toggle"
          >
            Recommended Detect Mode
            <span class="text-info" v-b-tooltip.hover :title="`Change the default attack policy to Detect, OWASP TOP10 or tool attacks are applicable. Save is required after setup`">
              <i class="fas fa-question-circle"></i>
            </span>
          </b-button>
          <b-button
            variant="outline-danger"
            class="float-left mr-2 ml-2"
            @click="toggle_default_block()"
            v-if="!base_crs.is_toggle"
          >
            Recommended Block Mode
            <span class="text-info" v-b-tooltip.hover :title="`Change the default attack policy to Block, OWASP TOP10 or tool attacks are applicable. Save is required after setup`">
              <i class="fas fa-question-circle"></i>
            </span>
          </b-button> -->
        </div>
      </template>
    </b-modal>
    <!-- 저장 확인 -->
    <b-modal title="Confirm"  class="modal-danger" v-model="confirm_modal" ok-variant="danger" header-bg-variant="danger" size="ml" no-close-on-esc no-close-on-backdrop @ok="save">
      <!-- {{crs_body.policy_list}} -->
      <div class="m-4">
        Changes will be reflected immediately upon saving and a window will be displayed to inform you of the success of the reflection Setting certain policies to block might cause service failure for some users
      </div>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
